// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1z08D","left":"StickyBox_left__2TOO8","right":"StickyBox_right__1-oCN"};